import { render, staticRenderFns } from "./marketing-materials.vue?vue&type=template&id=45e2a5c0&lang=pug&"
import script from "./marketing-materials.vue?vue&type=script&lang=js&"
export * from "./marketing-materials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports